module.exports = __webpack_public_path__ + "static/media/how-it-works-girl-image.72a64cc6.png";